import React from 'react';
import { Text, View } from 'react-native';

import defaultStyles from './LabelItem.jss';

type LabelItemProps = {
    label: string;
};

const LabelItem = ({ label }: LabelItemProps): JSX.Element => (
    <View style={defaultStyles.container}>
        <Text style={defaultStyles.textContainer}>{label}</Text>
    </View>
);

export default LabelItem;
